import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const sx = {
  container: {
    height: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
  barcontainer: {
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%',
    width: '64px',
    height: '100%',
    float: 'left',
    borderRadius: '5px 5px 0px 0px',
  },
  bar: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    boxSizing: 'border-box',
    animation: '$grow 1.5s ease-out forwards',
    transformOrigin: 'bottom',
    borderRadius: '5px 5px 0px 0px',
    display: 'flex',
    justifyContent: 'center',
  },
  '@keyframes grow': {
    from: {
      transform: 'scaleY(0)',
    },
  },
  totalTag: {
    position: 'absolute',
    fontSize: '11px',
    fontWeight: '550'
  },
  yAxis: {
    transform: 'rotate(-90deg)',
    left: '-35px',
    position: 'absolute'
  }
};

// Function to get color based on range
const getColorByRange = (range) => {
  // Handle coding mock ranges (1.2-2.33, 2.34-3.67, 3.68-5.0)
  if (range.includes('1.2-2.33')) return '#C51407';
  if (range.includes('2.34-3.67')) return '#F5B847';
  if (range.includes('3.68-5.0')) return '#00664A';
  
  // Handle regular percentage ranges (0-30, 31-60, 61-100)
  if (range.includes('0-30')) return '#C51407';
  if (range.includes('31-60')) return '#F5B847';
  if (range.includes('61-100')) return '#00664A';
  
  // Default fallback
  return '#C51407';
};

export const BarContainer = ({ height, color, total, range }) => {
  const barColor = getColorByRange(range);
  
  return (
    <Box sx={sx.barcontainer}>
      <Box
        sx={sx.bar}
        style={{
          height: `${height}%`,
          backgroundColor: barColor,
        }}
      >
        <Typography sx={{...sx.totalTag, top: height === 100 ? '2px' : '-15px',}}>
          { total > 0 && total }
        </Typography>
      </Box>
    </Box>
  );
};

const VerticalGraph = ({
  averageScoreStats, averageScoreLegends, xAsix, yAsix, totalStudents
}) => {

  return (
    <Box  display='flex' flexDirection='column' gap='15px'>
      <Box display="flex" alignItems="center" height='143px' position='relative' 
        paddingLeft='24px' borderLeft= "1px solid #8692A3" borderBottom="1px solid #8692A3"
      >
      <Typography
                        variant='body01-bold' 
                        color='neutral.clr-600'
                        component="div"
                        style={{ transform: "rotate(-90deg)" , position:'absolute' , top:70,left:-74}}
                    >
                       {yAsix}
                    </Typography>
                 <Box sx={sx.container} width='100%'>
           {
             averageScoreLegends?.map((data,index)=>{
               return (
                 <Box key={index}>              
                   <BarContainer 
                     height={(averageScoreStats[data.range]/(totalStudents))*100 || 0}
                     color={data.color}
                     total={averageScoreStats[data.range]}
                     range={data.range}
                   /><br/>
                   <Typography variant='body02-semiBold'>
                     { data?.range }
                   </Typography>
                 </Box>
               )
             })
           }
         </Box>
      </Box>
      <Box textAlign='center' mt={2} > 
        <Typography variant='body01-bold' color='neutral.clr-600'>
          { xAsix }
        </Typography>
      </Box>
    </Box>
  );
};

export default VerticalGraph;
